<script setup lang="ts">
import PlaylistPanel from '@/components/views/channelMediaView/PlaylistPanel.vue';
import type { ChannelDetail } from '@/types/channelTypes';
import type { Media } from '@/types/mediaTypes';

interface Props {
  channelMedia: Media;
  channelDetails: ChannelDetail;
}

defineProps<Props>();
</script>

<template>
  <playlist-panel
    :channel-media="channelMedia"
    :channel-details="channelDetails"
  />
</template>
